import { socialExport } from '@mi-front/api-clients';
import { Alert, AlertTitle } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { StationCard } from './StationCard';
import { Station } from '@app/core/types/stations';

interface Props {
  platform: SocialPlatform;
  station: Station;
  state?: socialExport.GetConnectionStateDto;
}

function NonEnabledFeature() {
  return (
    <Alert severity="warning">
      <AlertTitle>
        <FormattedMessage
          id="socialExport.featureNotEnabled"
          defaultMessage="Feature no activado, consulte a soporte"
        />
      </AlertTitle>
    </Alert>
  );
}

export function NonConnectedStationFeature({ platform, station, state }: Props) {
  return (
    <StationCard station={station} sx={{ mb: 2 }}>
      <NonEnabledFeature />
    </StationCard>
  );
}
